// extracted by mini-css-extract-plugin
export default {"list":"OrganizationsPreviewsList_list__87JPC","list__item":"OrganizationsPreviewsList_list__item__n8Vfc"};